import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const Editable = ({
  childRef,
  text,
  type,
  firstEdit,
  setShowTable,
  placeholder,
  children,
  batch_id,
  ...props
}) => {
  const [isEditing, setEditing] = useState(firstEdit);
  const [isFirstEdit, setFirstEdit] = useState(firstEdit);

  const handleKeyDown = (event, type) => {
    if (event.keyCode === 13) setEditing(false);
  };

  //Initially was setting this up to save with previous step of group name first, HOWEVER
  //the scales of justice have determined the old way = bad, new way = good
  // so the workflow that was attached to this handleClick has been removed
  const handleClick = async () => {

    const createUTMPost = async () => {
      const url = `/wp-admin/admin-ajax.php?action=post_save_utm_codes`;

      await axios
        .post(url)
        .then((res) => {
          batch_id = res.data.data;
        })
        .catch((err) => console.log(err));
    };

    await createUTMPost();
    setShowTable(true);
    setEditing(false);
    setFirstEdit(false);
  };

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  return (
    <section {...props}>
      {isEditing ? (
        <div>
            <div
              className="u--display-flex"
              onBlur={() => setEditing(false)}
              onKeyDown={(e) => handleKeyDown(e, type)}
            >
              {children}
              <button className="btn btn--blue u--margin-left-10">
                <span className="btn__content">
                  <span className="btn__text">Ok</span>
                </span>
              </button>
            </div>
        </div>
      ) : (
        <div onClick={() => setEditing(true)} className="u--display-flex">
          <span className="u--font-size-lg u--margin-right-5">
            {text || placeholder || 'Editable content'}
          </span>
          <FontAwesomeIcon
            icon={faPencilAlt}
            className="group-input__pencil-icon"
          />
        </div>
      )}
    </section>
  );
};

export default Editable;
